import type { TransactionStatusPillStatus } from "@/modules/shared";

import type { OrderStatus } from "../types";

export const convertOrderStatusToStatusPill = (
  status: OrderStatus
): TransactionStatusPillStatus => {
  switch (status) {
    case "active":
      return "active";

    case "done":
      return "done";

    case "paid":
      return "paid";

    case "cancelled":
      return "cancelled";

    case "failed":
      return "failed";

    case "order_created":
    case "waiting_for_payment":
      return "waiting_for_payment";

    default:
      return "new";
  }
};
